module.exports = __webpack_public_path__ + "img/om-logo-header.8c595a47.svg";